<template>
  <PageHeader
    title="Tudáspróba"
    hero-class="bg-folkszemle hidden lg:flex"
    :breadcrumb="['Folkszemle','Tudáspróba']"
  >
    <section
      id="game"
      class="w-full bg-white "
      @keyup.enter="$refs.search.submit()"
    >
      <ReOverlayLoader :loading="waitForNewQuestion">
        <div
          v-if="!question"
          class="p-[15px] lg:p-[50px]"
        >
          <p class="text-center ">
            Népzenéről és néptáncról szóló kvíz, melynek segítségével felmérheted
            tudásodat és játékosan tanulhatsz. <br>
            <span class="text-red uppercase text-2xl mt-2"> Jó szórakozást! </span>
          </p>
          <img
            class="w-[70px] mx-auto mt-[75px] mb-[25px]"
            src="/img/tudasproba_icon.svg"
            alt=""
          >
          <p class="text-center font-semibold">
            Jelöld meg, milyen szintű kérdéseket kérsz!
          </p>
          <div class="flex flex-col lg:flex-row gap-x-8 justify-center my-8">
            <ReCheckbox
              v-model="levels[0]"
              type="left"
            >
              Kezdő
            </ReCheckbox>
            <ReCheckbox
              v-model="levels[1]"
              type="left"
            >
              Középhaladó
            </ReCheckbox>
            <ReCheckbox
              v-model="levels[2]"
              type="left"
            >
              Haladó
            </ReCheckbox>
          </div>
          <button
            :disabled="!levels[0] && !levels[1] && !levels[2]"
            class="my-4  px-12 btn btn-red mx-auto"
            type="button"
            @click.prevent="getQuestions(true)"
          >
            <span>Kezdjük!</span>
          </button>
        </div>

        <!-- question -->
        <div
          v-if="question"
        >
          <div class="bg-red-lightest text-center py-[18px]  mb-4">
            <h4
              id="question"
              class="text-2xl"
            >
              {{ question.question }}
              <span
                v-if="isAdmin()"
                class="action-buttons"
              >
                <nuxt-link
                  :to="
                    '/admin/folkszemle/tudasproba/kerdes/' + question.id
                  "
                  class="text-center"
                >
                  <i
                    class="fas fa-cog pr-0"
                    title="Kérdés szerkesztése"
                  />
                </nuxt-link>
              </span>
            </h4>
            <p>
              {{
                rightAnswerCount() > 1
                  ? "Jelöld meg az összes helyes választ!"
                  : "Jelöld meg az egyetlen helyes választ!"
              }}
            </p>
          </div>
          <!-- img / audio -->
          <div class="flex">
            <div
              v-for="media in question.media"
              :key="media.file.id"
              class="mx-auto text-center"
            >
              <picture
                v-if="media.file.mime_type.includes('image')"
                class="img-responsive w-96"
              >
                <img
                  :src="media.file.url"
                  class="w-96"
                >
              </picture>
              <audio
                v-if="media.file.mime_type.includes('audio') || media.file.mime_type.includes('octet')"
                controls
                class="img-responsive w-96"
              >
                <source
                  :src="encodeURI(media.file.url)"
                  :type="media.file.mime_type"
                >
                A böngésződ nem támogatja a beágyazott audio tartalmakat!
              </audio>
              <video
                v-if="media.file.mime_type.includes('video')"
                controls
                class="img-responsive w-96"
              >
                <source
                  :src="encodeURI(media.file.url)"
                  :type="media.file.mime_type"
                >
                A böngésződ nem támogatja a beágyazott video tartalmakat!
              </video>
              <br>
              <span v-if="media.urlMedia && media.file.original">Forrás:</span>
              <a
                v-if="media.urlMedia"
                :href="media.file.original"
                target="_blank"
                class="link-yellow underline"
              >{{ media.file.original }}</a>
            </div>
          </div>
       

          <!-- center -->
          <div class="flex flex-col lg:flex-row gap-x-6 w-full mx-auto">
            <div class="w-full py-[20px]">
              <div
                v-for="(answer, index) in question.answers"
                :key="question.id + '-' + answer.id"
              >
                <ReCheckbox
                  v-model="answers[questionIndex][index]"
                  :class="{ 'bg-green': showAnswer && answer.right , 'bg-[#F6F6F6]':(answers[questionIndex][index]!== answer.right) && showAnswer && !answer.right}"
                  :disabled="showAnswer"
                  type="left"
                  class="px-[40px]"
                >
                  <span v-html="answer.answer" />
                  <img
                    src="/img/knowladgement_false.svg" 
                    class="block float-right"
                    :class="{ 'hidden':! ((answers[questionIndex][index]!== answer.right) && showAnswer && !answer.right)}"
                    alt=""
                  >
                </ReCheckbox>
              </div>
            </div>
            <div class="w-full lg:hidden">
              <p
                v-show="currentAnswer !== null"
                class="uppercase text-center lg:text-left"
                :class="{'text-red': currentAnswer === false,
                         'text-green': currentAnswer === true}"
              >
                {{
                  currentAnswer === true
                    ? "Helyes válasz, gratulálunk!"
                    : "Helytelen válasz"
                }}
              </p>
            </div>
            <div class="w-full lg:hidden">
              <button
                v-show="!showAnswer"
                id="show"
                class="my-4  px-12 btn btn-red mx-auto"
                type="button"
                @click="revealResult"
              >
                <span>Lássuk a helyes választ!</span>
              </button>
              <button
                v-show="showAnswer"
                id="new"
                :disabled="questionIndex === maxIndex || finished"
                class="my-4  px-12 btn btn-yellow mx-auto"
                type="button"
                @click="
                  showAnswer = false;
                  nextQuestion();
                "
              >
                <span>{{
                  finished ? "Elfogytak a kérdések" : "Új kérdés"
                }}</span>
              </button>
            </div>
            
            <div
              v-if="answered > 0"
              class="w-full lg:w-96 p-[20px]"
            >
              <!-- eredmeny box -->
              <div
                v-if="answered > 0"
                class="border border-red-lightest mb-4 p-[15px] lg:p-[20px] text-center"
              >
                <h3 class="text-xl font-bold font-source-serif-pro">
                  Eredmény
                </h3>

                <p class="mt-3">
                  {{ goodAnswers }} helyes válasz {{ answered }} kérdésből
                </p>
                <h1 class="text-[#F9A72D] text-5xl font-source-serif-pro ">
                  {{
                    answered > 0 ? Math.ceil((goodAnswers / answered) * 100) : 0
                  }}
                  %<br>
                </h1>
                <p v-if="Math.ceil((goodAnswers / answered) * 100) > 80">
                  Gratulálunk!
                </p>
              </div>
              <!-- nezz utana -->
              <div
                v-if="
                  answered - 1 === questionIndex &&
                    (question.literature || question.links.length>0)
                "
                class="border border-red-lightest mb-4 p-[15px] lg:p-[20px] text-center"
              >
                <h3 class="text-xl font-bold font-source-serif-pro">
                  Nézz utána!
                </h3>

                <p
                  v-if="question.literature"
                  class="mt-1"
                >
                  <!-- <strong>Irodalom:</strong> <br> -->
                  <a
                    :href="question.literature.url"
                    target="_blank"
                    class="link-yellow underline"
                  >{{ question.literature.name }}
                  </a>
                </p>
                <p
                  v-if="question.links.length"
                >
                  <!-- <strong>Lásd még:</strong> -->
                  <span
                    v-for="link in question.links"
                    :key="link.url"
                  >
                    <a
                      :href="link.url"
                      class="link-yellow underline mt-1"
                      target="_blank"
                    >{{ link.name }}
                    </a></span>
                </p>
              </div>
            <!-- <div
              v-if="stat.length"
              class="col-12 mt-3"
            >
              <div class="bg-light p-3 secondary-border quote-side text-center ">
                <h3 class="subtitle text-center">
                  Statisztika
                </h3>
                <p
                  class="mt-3"
                >
                  A legalább húsz kérdésre válaszolók száma az elért eredmény függvényében
                </p>
                <canvas
                  id="myChart"
                  class="w-100"
                />
              </div>
            </div> -->
            </div>
          </div>
          <!-- bottom -->
          <div class="flex flex-col lg:flex-row gap-x-6 px-[40px]  lg:mx-auto items-center">
            <div class="hidden lg:block lg:w-full">
              <p
                v-show="currentAnswer !== null"
                class="uppercase text-center lg:text-left"
                :class="{'text-red': currentAnswer === false,
                         'text-green': currentAnswer === true}"
              >
                {{
                  currentAnswer === true
                    ? "Helyes válasz, gratulálunk!"
                    : "Helytelen válasz"
                }}
              </p>
            </div>
            <div class="hidden lg:block lg:w-full">
              <button
                v-show="!showAnswer"
                id="show"
                class="my-4  px-12 btn btn-red mx-auto"
                type="button"
                @click="revealResult"
              >
                <span>Lássuk a helyes választ!</span>
              </button>
              <button
                v-show="showAnswer"
                id="new"
                :disabled="questionIndex === maxIndex || finished"
                class="my-4  px-12 btn btn-yellow mx-auto"
                type="button"
                @click="
                  showAnswer = false;
                  nextQuestion();
                "
              >
                <span>{{
                  finished ? "Elfogytak a kérdések" : "Új kérdés"
                }}</span>
              </button>
            </div>
            <div class="w-full text-center lg:text-right">
              <a
                href="#"
                class="link-yellow underline"
                @click.prevent="questionIndex = null; showAnswer = false"
              >Szintválasztás</a>
            </div>
          </div>

        <!-- old
        <div class="row">
          <div
            :class="{
              'col-lg-12': !(
                answered > 0 ||
                question.literature ||
                question.links.length
              )
            }"
            class="col-xs-12 col-lg-9"
          >
            <div
              v-if="!waitForNewQuestion" 
              class="row"
            >
              <div class="col-12">
                <div class="row justify-content-center">
                  <div
                    v-for="media in question.media"
                    :key="media.file.id"
                    :class="{
                      'col-4': question.media.length === 3,
                      'col-12 col-lg-6': question.media.length < 3
                    }"
                    class="w-100 text-center"
                  >
                    <picture
                      v-if="media.file.mime_type.includes('image')"
                      class="img-responsive w-100"
                    >
                      <img
                        :src="media.file.url"
                        class="w-100"
                      >
                    </picture>
                    <audio
                      v-if="media.file.mime_type.includes('audio') || media.file.mime_type.includes('octet')"
                      controls
                      class="img-responsive w-100"
                    >
                      <source
                        :src="encodeURI(media.file.url)"
                        :type="media.file.mime_type"
                      >
                      A böngésződ nem támogatja a beágyazott audio tartalmakat!
                    </audio>
                    <video
                      v-if="media.file.mime_type.includes('video')"
                      controls
                      class="img-responsive w-100"
                    >
                      <source
                        :src="encodeURI(media.file.url)"
                        :type="media.file.mime_type"
                      >
                      A böngésződ nem támogatja a beágyazott video tartalmakat!
                    </video>
                    <br>
                    <span v-if="media.urlMedia && media.file.original">Forrás:</span>
                    <a
                      v-if="media.urlMedia"
                      :href="media.file.original"
                      target="_blank"
                    >{{ media.file.original }}</a>
                  </div>
                  <div class="col-12">
                    <div class="bg-color-3">
                      <h4
                        id="question"
                        class="pl-2 pb-1"
                      >
                        {{ question.question }}
                        <span
                          v-if="isAdmin()"
                          class="action-buttons"
                        >
                          <nuxt-link
                            :to="
                              '/admin/folkszemle/tudasproba/kerdes/' + question.id
                            "
                            class="text-center"
                          >
                            <i
                              class="fas fa-cog pr-0"
                              title="Kérdés szerkesztése"
                            />
                          </nuxt-link>
                        </span>
                      </h4>
                      <p class="pl-2 pb-3 tip">
                        {{
                          rightAnswerCount() > 1
                            ? "Jelöld meg az összes helyes választ!"
                            : "Jelöld meg az egyetlen helyes választ!"
                        }}
                      </p>
                    </div>
                  </div>
                  <div
                    v-for="(answer, index) in question.answers"
                    :key="question.id + '-' + answer.id"
                    class="col-12 ml-3"
                  >
                    <ReCheckbox
                      v-model="answers[questionIndex][index]"
                      :class="{ 'good-answer': showAnswer && answer.right }"
                      :disabled="showAnswer"
                      type="left"
                    >
                      <span v-html="answer.answer" />
                    </ReCheckbox>
                  </div>
                </div>
              </div>
              <div class="col-12 col-lg-4 pt-2 text-center text-lg-left ">
                <p
                  v-show="currentAnswer !== null"
                  class="answer-text"
                >
                  {{
                    currentAnswer === true
                      ? "Helyes válasz, gratulálunk!"
                      : "Helytelen válasz"
                  }}
                </p>
              </div>
              <div class="col-12 col-lg-4 text-center">
                <button
                  v-show="!showAnswer"
                  id="show"
                  class="mt-2 mb-4 btn btn-red"
                  type="button"
                  @click="revealResult"
                >
                  <span>Lássuk a helyes választ!</span>
                </button>
                <button
                  v-show="showAnswer"
                  id="new"
                  :disabled="questionIndex === maxIndex || finished"
                  class="mt-2 mb-4 btn btn-primary pl-5 pr-5"
                  type="button"
                  @click="
                    showAnswer = false;
                    nextQuestion();
                  "
                >
                  <span>{{
                    finished ? "Elfogytak a kérdések" : "Új kérdés"
                  }}</span>
                </button>
              </div>
              <div class="col-12 col-lg-4 text-center text-lg-right pt-2 mb-3">
                <a
                  href="#"
                  @click.prevent="questionIndex = null; showAnswer = false"
                >Szintválasztás</a>
              </div>
            </div>
            <div
              v-else
              class="row"
            >
              <div class="col-12">
              
              </div>
            </div>
          </div>

          <div
            v-if="answered > 0"
            class="col-xs-12 col-lg-3"
          >
            <div class="row">
              <div
                v-if="answered > 0"
                class="col-12"
              >
                <div
                  class="bg-light p-3 secondary-border quote-side text-center "
                >
                  <h3 class="subtitle text-center">
                    Eredmény
                  </h3>

                  <p class="mt-3">
                    {{ goodAnswers }} helyes válasz {{ answered }} kérdésből
                  </p>
                  <h1 class="result-title">
                    {{
                      answered > 0 ? Math.ceil((goodAnswers / answered) * 100) : 0
                    }}
                    %<br>
                  </h1>
                  <p v-if="Math.ceil((goodAnswers / answered) * 100) > 80">
                    Gratulálunk!
                  </p>
                </div>
              </div>
              <div
                v-if="
                  answered - 1 === questionIndex &&
                    (question.literature || question.links.length)
                "
                class="col-12 mt-3"
              >
                <div class="bg-light p-3 secondary-border quote-side">
                  <h3 class="subtitle text-center">
                    Nézz utána!
                  </h3>

                  <p
                    v-if="question.literature"
                    class="mt-3"
                  >
                   
        <a
          :href="question.literature.url"
          target="_blank"
        >{{ question.literature.name }}
        </a>
        </p>
        <p
          v-if="question.links.length"
          class="mt-3"
        >
          <span
            v-for="link in question.links"
            :key="link.url"
          >
            <br><a
              :href="link.url"
              target="_blank"
            >{{ link.name }}
            </a></span>
        </p>
      </div>
      </div>
     
      </div>
      </div>
      </div>

      -->
        </div>
        <!-- social -->
        <div class="w-full flex flex-wrap place-content-center py-[20px] lg:py-[50px]">
          <facebook
            :url="metaUrl()"
            title="Facebook megosztás"
            button-class="mx-[8px]"
          />
          <twitter
            :url="metaUrl()"
            title="Twitter megosztás"
            button-class="mx-[8px]"
          />
          <email
            :url="metaUrl()"
            :subject="'Tudáspróba | Folkrádió'"
            :text="metaDescription()"
            title="Email küldés"
            button-class="mx-[8px]"
          />
        </div>
      </ReOverlayLoader>
    </section>
  </PageHeader>
</template>
<script>
import ReCheckbox from "~/components/rxt/reform/ReCheckbox.vue";
import PageHeader from "~/components/folkradio/PageHeader.vue";
import ReOverlayLoader from "~/components/rxt/recomponent/ReOverlayLoader.vue";

import facebook from "~/components/rxt/social/facebook.vue";
import twitter from "~/components/rxt/social/twitter.vue";
import email from "~/components/rxt/social/email.vue";
// import Chart from 'chart.js'
export default {
  components: {
    ReCheckbox,
    facebook,
    twitter,
    email,
    PageHeader,
    ReOverlayLoader
  },
  head() {
    return {
      titleTemplate: "Tudáspróba | Folkrádió",
      meta: [
        { hid: "title", name: "title", content: "Tudáspróba | Folkrádió" },
        {
          hid: "og:title",
          name: "og:title",
          property: "og:title",
          content: "Tudáspróba | Folkrádió"
        },
        {
          hid: "description",
          name: "description",
          content: 'Népzenéről és néptáncról szóló kvíz, melynek segítségével felmérheted tudásodat és játékosan tanulhatsz. Teszteld magad!'
        },
        {
          hid: "og:description",
          name: "og:description",
          property: "og:description",
          content: 'Népzenéről és néptáncról szóló kvíz, melynek segítségével felmérheted tudásodat és játékosan tanulhatsz. Teszteld magad!'
        },
        {
          hid: "og:site_name",
          name: "og:site_name",
          content: this.$getDomain() + "/folkszemle/tudasproba"
        },
        {
          hid: "og:site-name",
          name: "og:site-name",
          content: this.$getDomain() + "/folkszemle/tudasproba"
        },
        {
          hid: "og:image",
          name: "og:image",
          property: "og:image",
          content: this.$getDomain() + "/img/meta_default.png"
        }
      ]
    };
  },
  filters: {
    removeHtml(value) {
      // const div = document.createElement("div");
      // div.innerHTML = value;
      // return div.textContent || div.textContent || "";
      return value !== null ? value.replace(/<[^>]*>?/gm, '') : ''
    }
  },
  data() {
    return {
      waitForNewQuestion: false,
      questionIndex: null,
      // answered: null,
      entities: {
        data: []
      },
      stat: [],
      levels: [false, false, false],
      finished: false,
      maxIndex: null,
      showAnswer: false,
      currentAnswer: null,
      // goodAnswers: 0,
      answers: [],
      loading: false
    };
  },
  computed: {
    question() {
      return this.entities && this.questionIndex !== null
        ? this.entities.data[this.questionIndex]
        : null;
    },
    answered() {
      return this.$store.getters['getKnowledgebaseResult'].answered
    },
    goodAnswers() {
      return this.$store.getters['getKnowledgebaseResult'].goodAnswers
    }
  },
  watch: {
    $route(to, from) {
      this.$store.commit("search/setQueryObject", to.query);
      this.entities = {
        data: []
      }
      this.search();
    },
    answered() {
      if(this.answered > 0){
        let dataSet = []
        for(let i = 0; i <= 100; i+=5){
          let data = { x: i, y: 0}
          let item = this.stat.find((item, index) => {
            if(item.percentRound === i)
              return item
          })
          if(item){
            data.y = item.howMany
          }
          dataSet.push(data)
        }
        // setTimeout(() =>{
        //   new Chart('myChart', {
        //     type: 'bar',
        //     data:  {
        //       labels: dataSet.map(item => {return item.x}),
        //       datasets: [
        //         {
        //           backgroundColor: 'rgba(255, 0, 0, 0.3)',
        //           barPercentage: 0.5,
        //           // label: 'A százalékot elértek száma',
        //           data: dataSet
        //         }
        //       ]
        //     },
        //     options: {
        //       legend: {
        //           display: false,
        //       },
        //       aspectRatio: 1,
        //       scales: {
        //           xAxes: [{
        //               offset: false,
        //               gridLines: {
        //                   offsetGridLines: false
        //               }
        //           }],
        //           yAxes: [{
        //               ticks: {
        //                   beginAtZero: true,
        //                   stepSize: 1
        //               }
        //           }]
        //       }
        //     }
        //   });
        // }, 150)
      }
    }
  },
  async fetch() {
    let result = this.$store.getters['getKnowledgebaseWindowResult']

    
      // eslint-disable-next-line
    let response = await this.$axios.get("knowledge/questions/stat");
    this.stat = response.data.data

    this.waitForNewQuestion = false
    if(result.question){
      this.waitForNewQuestion = true
      //set first question as answered
      this.entities.data.push(result.question);
      this.$store.commit('incKnowledgebaseAnswered')
      // this.answered++;

      //set question answers array
      this.answers[0] = []
      result.question.answers.forEach((a, aindex) => {
        if(result.right && a.right === true){
          this.answers[0][aindex] = true
        } else {
          this.answers[0][aindex] = false
        }
      });
      
      this.levels = [true,true,true]
      this.questionIndex = 0
      if(result.right){
        this.$store.commit('incKnowledgebaseGoodAnswers')
        // this.goodAnswers++
      }
      await this.getQuestions()
      this.nextQuestion()
    }
  },
  key: route => route.query.game,
  methods: {
    metaUrl() {
      return this.$getDomain() + "/folkszemle/tudasproba";
    },
    metaDescription() {
      return "Népzenéről és néptáncról szóló kvíz, melynek segítségével felmérheted tudásodat és játékosan tanulhatsz.";
    },
    rightAnswerCount() {
      let count = 0;
      this.question.answers.forEach(item => {
        if (item.right) {
          count++;
        }
      });
      return count;
    },
    currentQuestionHasAnswer() {
      for (let i = 0; i < this.answers[this.questionIndex].length; i++) {
        if (this.answers[this.questionIndex][i] === true) {
          return true;
        }
      }
      return false;
    },
    async getQuestions(reset = false) {
      let levelsQuery = "";
      this.loading = true;

      this.levels.forEach((item, index) => {
        if (item) {
          levelsQuery += (index + 1) + (index !== (this.levels.length - 1) ? ',' : '');
        }
      });

      // eslint-disable-next-line
      let response = await this.$axios.get(
        "knowledge/questions?limit=5&sort=random&filter[level]=" + levelsQuery, { useCache: false }
      );

      this.loading = false;
      if (reset) {
        this.entities.data = [];
      }
      response.data.data.forEach((item, index) => {
        if (
          !this.entities.data.find(i => {
            return item.id === i.id;
          })
        ) {
          this.entities.data.push(item);
        }
      });
      this.maxIndex = this.entities.data.length - 1;

      if (this.questionIndex === null || reset) {
        await this.nextQuestion(true);
      }

      if (this.questionIndex === this.maxIndex) {
        this.finished = true;
      }
    },
    revealResult() {
      this.showAnswer = true;
      this.$store.commit('incKnowledgebaseAnswered')
      // this.answered++;

      // calculate result for previous question
      let bad = false;
      this.entities.data[this.questionIndex].answers.forEach((a, aindex) => {
        if (
          this.answers[this.questionIndex][aindex] === true &&
          this.entities.data[this.questionIndex].answers[aindex].right === false
        ) {
          bad = true;
        } else if (
          this.answers[this.questionIndex][aindex] === false &&
          this.entities.data[this.questionIndex].answers[aindex].right === true
        ) {
          bad = true;
        }
      });
      if (!bad) {
        this.$store.commit('incKnowledgebaseGoodAnswers')
        // this.goodAnswers++;
        this.currentAnswer = true;
      } else {
        this.currentAnswer = false;
      }

      this.$axios.$post('/knowledge/answers', {
        question_id: this.entities.data[this.questionIndex].id,
        right: this.currentAnswer
      }).catch(error => {
        console.log(error.response)
      })
    },
    nextQuestion(reset = false) {
      this.waitForNewQuestion = false
      if (this.questionIndex === this.maxIndex) {
        return;
      }

      this.currentAnswer = null;
      // init question index
      if (this.questionIndex === null || reset) {
        // this.$store.commit('resetKnowledgebase')
        // this.answered = 0;
        // this.goodAnswers = 0;
        this.questionIndex = 0;
        this.goodAnswers = 0;
        this.answers = [];
        this.finished = false;
      } else {
        // increase index
        this.questionIndex++;
      }

      if (this.questionIndex === this.maxIndex && !this.finished) {
        this.getQuestions();
      }

      // init new question answers index
      this.answers[this.questionIndex] = [];

      this.entities.data[this.questionIndex].answers.forEach(
        (answer, index) => {
          this.answers[this.questionIndex][index] = false;
        }
      );

      // setTimeout(() => {
        document.getElementById('game').scrollIntoView({block: "start", inline: "nearest"})
      // }, 150);
    },
    getMainImg(entity) {
      if (entity.thumbnail && entity.thumbnail.photo) {
        return entity.thumbnail.photo.url + entity.thumbnail.photo.name;
      }
      return "/img/event-default_w240.jpg";
    },
    getMainQuoteImg(entity) {
      if (entity.image && entity.image.url) {
        return entity.image.url;
      }
      return null;
    }
  }
};
</script>
